import React from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton, Button, Box, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import Typography from '@mui/material/Typography';
import moment from 'moment';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '100%',
    maxHeight: '100vh',
    backgroundColor: 'white',
    overflow: 'auto',
    padding: '20px',
    margin: '20px',
    p: 4,
    WebkitOverflowScrolling: 'touch',
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
};

function TableComponent({ open, onClose, title, scanID, subScanID, scanDetails, kernals }) {
    const filteredArray = kernals && kernals.length > 0 && kernals.filter(obj => obj.scan_id === scanID && obj.sub_scan_id === subScanID);
    const rows = [];
    let headers = [
        {
            label: "",
            align: "left",
            headerColor: "#fff",
            renderer: (value, indexColumn, indexRow, row, rectRow, rectCell) => {
                return ``;
            }
        },
        {
            label: "Particulars",
            align: "left",
            headerColor: "#fff"
        }
    ];

    if (scanDetails?.kernel_details?.overall_score_grading) {
        headers.push({
            label: "Grade",
            align: "left",
            headerColor: "#fff"
        });
    } else {

    }
    headers.push({
        label: "Count",
        align: "left",
        headerColor: "#fff"
    });
    headers.push({
        label: "Count %",
        align: "left",
        headerColor: "#fff"
    });
    if (parseFloat(scanDetails?.kernel_details?.total_kernel_weight) > 0) {
        headers.push({
            label: "Weight (gm)",
            align: "left",
            headerColor: "#fff"
        });
        headers.push({
            label: "Weight (%)",
            align: "left",
            headerColor: "#fff"
        });
    }

    if (scanDetails?.kernel_details?.consider_area) {
        headers.push({
            label: "Area (mm2)",
            align: "left",
            headerColor: "#fff"
        });
    }

    if (scanDetails?.kernel_details?.consider_length) {
        headers.push({
            label: "Length (mm)",
            align: "left",
            headerColor: "#fff"
        });
    }
    headers.push({
        label: "Total Mistakes",
        align: "left",
        headerColor: "#fff"
    });
    headers.push({
        label: "% Accuracy",
        align: "left",
        headerColor: "#fff"
    });
    const firstRow = [];
    firstRow.push("");
    firstRow.push(scanDetails?.kernel_details?.beautify?.translations?.total_kernel_count);

    if (scanDetails?.kernel_details?.overall_score_grading) {
        firstRow.push(scanDetails?.kernel_details?.overall_score_grading);
    } else {

    }
    firstRow.push(scanDetails?.kernel_details?.total_kernel_count);
    firstRow.push("100%");
    if (parseFloat(scanDetails?.kernel_details?.total_kernel_weight) > 0) {
        firstRow.push(parseFloat(scanDetails?.weight_value) > 0 ? parseFloat(scanDetails?.weight_value).toFixed(2) : parseFloat(scanDetails?.kernel_details?.total_kernel_weight).toFixed(2))
        firstRow.push("100%");
    }
    if (scanDetails?.kernel_details?.consider_area) {
        firstRow.push("")
    }
    if (scanDetails?.kernel_details?.consider_length) {
        firstRow.push("")
    }
    rows.push(firstRow);

    let totalCount = 0;
    let accuracy;
    scanDetails?.kernel_details?.classes.forEach((key, index) => {
        let row = [];
        row.push({
            cellType: 'box',
            color: scanDetails?.processed_image?.encoding_colors[key],
        });
        row.push(scanDetails?.kernel_details?.beautify?.translations?.kernel_counts[key] + " (" + scanDetails?.processed_image?.encodings[key] + ")");

        if (scanDetails?.kernel_details?.overall_score_grading) {
            row.push(scanDetails?.kernel_details?.grading[key]);
        } else {

        }
        row.push(Number(scanDetails?.kernel_details?.kernel_counts[key]));
        row.push(` ${Number(scanDetails?.kernel_details?.kernel_counts[key] / scanDetails?.kernel_details?.total_kernel_count * 100).toFixed(2)}%`);
        if (parseFloat(scanDetails?.kernel_details?.total_kernel_weight) > 0) {
            let weightKey = scanDetails?.kernel_details?.kernel_weights ? scanDetails?.kernel_details?.kernel_weights : scanDetails?.kernel_details?.kernel_weight
            if (parseFloat(scanDetails?.weight_value) === 0) {
                row.push(Number(weightKey[key]).toFixed(2))
                row.push(Number(weightKey[key] / scanDetails?.kernel_details?.total_kernel_weight * 100).toFixed(2) + "%")
            } else {
                const weightedPercentageOfTotal = Number(weightKey[key] / scanDetails?.kernel_details?.total_kernel_weight * 100)
                const finalWeightFromSampleWeight = Number(weightedPercentageOfTotal * parseFloat(scanDetails?.weight_value ? scanDetails?.weight_value : scanDetails?.kernel_details?.total_kernel_weight) / 100)
                row.push(Number(finalWeightFromSampleWeight).toFixed(2))
                row.push(Number(weightKey[key] / scanDetails?.kernel_details?.total_kernel_weight * 100).toFixed(2) + "%")
            }
        }

        if (scanDetails?.kernel_details?.consider_area) {
            row.push(Number(scanDetails?.kernel_details?.areas[key]).toFixed(2));
        }

        if (scanDetails?.kernel_details?.consider_length) {
            row.push(Number(scanDetails?.kernel_details?.kernel_lengths[key]).toFixed(2));
        }
        const filteredData = filteredArray && filteredArray.filter((item) => item.original_class_name === key);
        const uniqueCombinations = new Map();
        filteredData && filteredData.forEach((obj) => {
            const combination = `${obj.review_index}-${obj.original_class_name}`;
            if (!uniqueCombinations.has(combination)) {
                uniqueCombinations.set(combination, obj);
            } else {
                const existingObj = uniqueCombinations.get(combination);
                const existingDate = moment(existingObj.created_at, 'DD MMM, YYYY hh:mm A');
                const currentDate = moment(obj.created_at, 'DD MMM, YYYY hh:mm A');

                if (currentDate.isAfter(existingDate)) {
                    uniqueCombinations.set(combination, obj);
                }
            }
        });
        const filteredKernel = Array.from(uniqueCombinations.values()).filter(obj => obj.original_class_name !== obj.changed_class_name);
        const count = filteredKernel ? filteredKernel.length : 0;
        totalCount += count; // Increment the count
        if (filteredData) {
            row.push(Number(count));
        } else {
            row.push(0);
        }
        const numerator = Number(scanDetails?.kernel_details?.kernel_counts[key]) - count;
        const denominator = Number(scanDetails?.kernel_details?.kernel_counts[key]);
        accuracy = denominator !== 0 ? ((numerator / denominator) * 100).toFixed(2) + "%" : "0%";
        if (accuracy) {
            row.push(accuracy);
        }
        rows.push(row);
    });

    const middleRows = [];
    middleRows.push("");
    middleRows.push("Total");
    if (scanDetails?.kernel_details?.overall_score_grading) {
        middleRows.push('');
    } else {
        middleRows.push('');
        middleRows.push("");
    }
    if (parseFloat(scanDetails?.kernel_details?.total_kernel_weight) > 0) {
        middleRows.push('');
        middleRows.push("");
    }
    if (scanDetails?.kernel_details?.consider_area) {
        middleRows.push("")
    }
    if (scanDetails?.kernel_details?.consider_length) {
        middleRows.push("")
    }
    if (filteredArray) {
        middleRows.push(totalCount)
    }
    if (accuracy) {
        middleRows.push(((Number(scanDetails?.kernel_details?.total_kernel_count) - Number(totalCount)) / Number(scanDetails?.kernel_details?.total_kernel_count) * 100).toFixed(2) + "%");
    }
    rows.push(middleRows);
    const lastRow = [];
    lastRow.push("");
    lastRow.push("Moisture");
    if (scanDetails?.moisture_value) {
        lastRow.push(scanDetails?.moisture_value ? `${scanDetails.moisture_value}%${scanDetails.moisture_weight
            ? ` (${scanDetails.moisture_weight}gm)`
            : ""
            }` : 'NA');
    }
    rows.push(lastRow);

    const table = {
        title: "",
        subtitle: "",
        headers: headers,
        rows: rows
    };
    const exportToCSV = () => {
        const csvRows = [];
        const firstTableHeaderRow = [
            'User Name',
            'Email/Phone Number',
            'ScanID',
            'Sub ScanID',
            'Grain Type',
            'Machine',
            'Date',
            'Phone/Device Name',
            'Location',
        ];
        csvRows.push(firstTableHeaderRow.join(','));

        const firstTableRow = [
            `${scanDetails?.first_name} ${scanDetails?.last_name}`,
            scanDetails?.email && scanDetails?.phone_number
                ? `${scanDetails?.email} / ${scanDetails?.phone_number}`
                : scanDetails?.email || scanDetails?.phone_number,
            scanID,
            subScanID,
            `${scanDetails?.crop_name} - ${scanDetails?.variety_name}`,
            `${scanDetails?.machine_name} (${scanDetails?.machine_code})`,
            `"${scanDetails?.created_at}"`,
            `${scanDetails?.device_info}`,
            `"${scanDetails?.location_name}"`,
        ];
        csvRows.push(firstTableRow.join(','));

        csvRows.push('');
        csvRows.push('');
        const headerRow = table.headers.slice(1).map((column) => column.label);
        csvRows.push(headerRow.join(','));

        table.rows.forEach((row) => {
            const csvRow = row.slice(1).map((cell) => {
                const cellValue = cell.toString().replace(/"/g, '""');
                return `"${cellValue}"`;
            });
            csvRows.push(csvRow.join(','));
        });

        const csvData = csvRows.join('\n');
        const link = document.createElement('a');
        link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvData);
        link.target = '_blank';
        link.download = `${scanID} _ ${subScanID}.csv`;
        link.click();
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box style={style}>
                <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', marginBottom: '30px' }}>
                    <Typography variant="h6" component="div" id="modal-modal-title" style={{ marginLeft: '20px' }}>
                        {title}
                    </Typography>
                    <div style={{ marginLeft: 'auto' }}>
                        <Button variant="contained" onClick={exportToCSV}>Export CSV</Button>
                        <IconButton aria-label="close" onClick={onClose} style={{ marginLeft: '45px' }}>
                            <ClearIcon />
                        </IconButton>
                    </div>
                </div>
                <div style={{ marginTop: '30px', marginBottom: '30px' }}>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead style={{ backgroundColor: 'aliceblue', textAlign: "left" }}>
                                <TableRow>
                                    <TableCell>user Name</TableCell>
                                    <TableCell>Email/phoneNumber</TableCell>
                                    <TableCell>ScanID</TableCell>
                                    <TableCell>Sub ScanID</TableCell>
                                    <TableCell>Grain Type</TableCell>
                                    <TableCell>Machine</TableCell>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Phone/Device Name</TableCell>
                                    <TableCell>Location</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow style={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>
                                    <TableCell align="left">
                                        {`${scanDetails?.first_name} ${scanDetails?.last_name}`}
                                    </TableCell>
                                    <TableCell align="left">
                                        {scanDetails?.email && scanDetails?.phone_number ? (
                                            <span>
                                                {scanDetails?.email} / {scanDetails?.phone_number}
                                            </span>
                                        ) : (
                                            <span>
                                                {scanDetails?.email || scanDetails?.phone_number}
                                            </span>
                                        )}
                                    </TableCell>
                                    <TableCell align="left">
                                        {scanID}
                                    </TableCell>
                                    <TableCell align="left">
                                        {subScanID}
                                    </TableCell>
                                    <TableCell align="left">
                                        {scanDetails?.crop_name} {scanDetails?.variety_name}
                                    </TableCell>
                                    <TableCell align="left">
                                        {scanDetails?.machine_name} ({scanDetails?.machine_code})
                                    </TableCell>
                                    <TableCell align="left">
                                        {scanDetails?.created_at}
                                    </TableCell>
                                    <TableCell align="left">
                                        {scanDetails?.device_info}
                                    </TableCell>
                                    <TableCell align="left">
                                        {scanDetails?.location_name}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <div>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead style={{ backgroundColor: 'aliceblue', textAlign: "left" }}>
                                <TableRow>
                                    {table.headers.map((header, index) => (
                                        <TableCell key={index} align={header.align} >
                                            {header.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {table.rows.map((row, index) => (
                                    <TableRow key={index} style={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}>
                                        {row.map((cell, cellIndex) => (
                                            <TableCell key={cellIndex} align="left" style={{
                                                paddingRight: '50px',
                                            }}>
                                                {cell && cell.cellType === 'box' ? (
                                                    <div style={{ backgroundColor: cell.color, width: '20px', height: '20px' }}></div>
                                                ) : (
                                                    cell
                                                )}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </Box>
        </Modal>
    );

}

export default TableComponent;
